/**
*   Created By David Nuñez
*   Date: 19-Oct-2017
*/

import PropTypes from 'prop-types';
import moment from 'moment';

const { Component } = React;

const internals = {};

internals.Select = (props) => {

  const { value = '', placeholder = '', id = '', opts = [], onChange = () => {} } = props;

  const preventIOSFocus = (e) => {

    e.preventDefault();
  };

  return (
    <div id={ id } className="control-wrapper custom-ddl field-wrap ">
      <div className="hide"> { value || placeholder }</div>
      <select
        name={ id }
        onChange={ onChange }
        onFocus={ preventIOSFocus }
        onBlur={ preventIOSFocus }
        value={ value } >

        <option key={`${name}-default`} value="" selected>{ placeholder }</option>
        { opts }
      </select>
    </div>
  );
};

class LongDatePicker extends Component {

  constructor(props) {
    super(props);

    this.state = {
      month: '',
      day: '',
      year: '',
      date: '',
    };

    this.input = React.createRef();
  }

  componentDidMount() {

    // this.prepopulate();
  }

  prepopulate = () => {

    const { defaultValue, format } = this.props;
    let month = null;
    let day = null;
    let year = null;
    let date = null;
    const momentValue = moment(defaultValue);

    if (momentValue._isValid) {
      month = momentValue.month() + 1;
      day = momentValue.date();
      year = momentValue.year();
      date = momentValue.format(format);

      this.setState({ month, day, year, date }, this.triggerOnChange);
    }
  }

  triggerOnChange = () => {

    this.props.onChange({ target: this.input });

    this.input.current.focus();
    this.input.current.blur();

    if (!this.state.date) {
      $(`#${this.props.name}-error`).remove();
    }
  }

  handleChange = (event) => {

    event.preventDefault();

    const target = event.target;
    const name = target.name;
    const value = target.value;

    this.setState({ [`${name}`]: value }, this.updateDate);
  }

  updateDate = () => {
    const { month, day, year } = this.state;
    const { format } = this.props;
    let date = '';

    if (month && day && year) {
      date = moment(month + '/' + day + '/' + year, format).format(format);
    }

    if (date === 'Invalid date') {

      this.setState({ day: '', date: '' }, this.triggerOnChange);

      return;
    }

    this.setState({ date }, this.triggerOnChange);
  }

  preventIOSFocus(e) {

    e.preventDefault();
  }

  dayRestrictions(optionDay) {

    const { month, year } = this.state;
    const isNotLeapYear = !moment([year]).isLeapYear();

    // Return:
    //      True  - means disabled
    //      False - means enabled

    // Check if month has 30 days
    if (optionDay === 31 && (month === '2' || month === '4' || month === '6' || month === '9' || month === '11') ) {
      return true;
    }

    if (month === '2') {

      // Remove the day 30 from February
      if (optionDay === 30) {
        return true;
      }

      // Remove the day 29 if is not Leap Year
      if (isNotLeapYear && optionDay === 29) {
        return true;
      }
    }

    return false;
  }

  dayInputJSX = () => {

    /* eslint-disable */
    const { day } = this.state;
    /* eslint-enable */
    const { Select } = internals;
    const dayOpts = [];

    // Populate Options
    for (let x = 1; x <= 31; x++) {
      let option = null;

      if (x >= 29) {
        if(!this.dayRestrictions(x)) {
          option = (<option key={`dd-${x}`} value={ x }>{ x }</option>);
        }
      } else {
        option = (<option key={`dd-${x}`} value={ x }>{ x }</option>);
      }

      if(option) {
        dayOpts.push(option);
      }
    }


    return (
      <Select value={ this.state.day } placeholder="DD" id="day" opts={ dayOpts } onChange={ this.handleChange } />
    );
  }

  monthInputJSX = () => {

    const { month } = this.state;
    const { Select } = internals;
    const monthOpts = [];

    for (let x = 1; x <= 12; x++) {
      monthOpts.push(<option key={`mm-${x}`} value={ x }>{ x }</option>);
    }

    return (
      <Select value={ month } placeholder="MM" id="month" opts={ monthOpts } onChange={ this.handleChange } />
    );
  }

  yearInputJSX = () => {

    const { year } = this.state;
    let { maxYear } = this.props;
    const { minYear } = this.props;
    const { Select } = internals;
    const yearOpts = [];

    //  sometimes in final season of the year some users have departure date in the next year
    maxYear = maxYear + 3;

    if (this.props.incremental) {
      for (let x = minYear; x <= maxYear; x++) {
        yearOpts.push(<option key={`yy-${x}`} value={ x }>{ x }</option>);
      }
    } else {
      for (let x = maxYear; x >= minYear; x--) {
        yearOpts.push(<option key={`yy-${x}`} value={ x }>{ x }</option>);
      }
    }

    return (
      <Select value={ year } placeholder="YYYY" id="year" opts={ yearOpts } onChange={ this.handleChange } />
    );
  }

  render() {

    const { date } = this.state;

    return (
      <div className={`dropdown-wrapper ${this.props.wrapperClassName}`}>

        <div className="row">
          {(this.props.label && this.props.isRequired) ? 
          <label className={`form-label ${this.props.labelWrapper}`}>
            {`${this.props.labelName}`} <span>*</span>
          </label> : 
           (this.props.label && !this.props.isRequired) ?
           <label className={`form-label ${this.props.labelWrapper}`}>
            {`${this.props.labelName}`}
          </label> :
          ''}

          <div className={`${this.props.monthClassName} month-select`}>
            { this.monthInputJSX() }
          </div>

          <div className={`${this.props.dayClassName} day-select`}>
            { this.dayInputJSX() }
          </div>
          <div className={`${this.props.yearClassName} year-select`}>
            { this.yearInputJSX() }
          </div>
        </div>

        <div class='row long-date-input-error'>
          <input ref={this.input} className="ddl-text xs-12 date-input hide" name={ this.props.name } value={ date } required={this.props.isRequired} />
        </div>
      </div>
    );
  }
}

LongDatePicker.propTypes = {
  minYear: PropTypes.number,
  maxYear: PropTypes.number,
  incremental: PropTypes.bool,
  defaultValue: PropTypes.object,
  onChange: PropTypes.func,
  name: PropTypes.string,
  WrapperClassName: PropTypes.string,
  isRequired: PropTypes.bool,
  format: PropTypes.string,
  monthClassName: PropTypes.string,
  dayClassName: PropTypes.string,
  yearClassName: PropTypes.string,
  labelWrapper: PropTypes.string,
  labelName: PropTypes.string,
  label: PropTypes.bool,
};

LongDatePicker.defaultProps = {
  minYear: moment().subtract(110,'year').year(),
  maxYear: moment().year(),
  incremental: false,
  defaultValue: {},
  onChange: () => {},
  name: '',
  WrapperClassName: '',
  isRequired: false,
  format: 'MM/DD/YYYY',
  monthClassName: 'xs-4',
  dayClassName: 'xs-4',
  yearClassName: 'xs-4',
  labelWrapper: 'xs-3',
  labelName: 'Arrival Date',
  label: false,
};


export default LongDatePicker;
